"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCustomerMenuToInternalMenuItems = void 0;
const mapCustomerMenuToInternalMenuItems = (parentItemPath, items) => items.reduce((accumulatedValue, item, index) => {
  const {
    url,
    isViewable,
    title,
    icon,
    openInNewTab,
    subItems
  } = item;

  // Ignore items without title or url
  if (!title || !url) {
    return accumulatedValue;
  }
  const itemPath = `${parentItemPath}/${index}/`;
  const mappedItem = {
    itemPath,
    title,
    url,
    icon: icon ?? null,
    openInNewTab: openInNewTab ?? null,
    subItems: mapCustomerMenuToInternalMenuItems(itemPath, [...(subItems.length > 0 && url && isViewable ? [{
      url,
      title,
      isViewable: true,
      subItems: []
    }] : []), ...subItems]),
    isViewable
  };
  accumulatedValue.push(mappedItem);
  return accumulatedValue;
}, []);
exports.mapCustomerMenuToInternalMenuItems = mapCustomerMenuToInternalMenuItems;